// extracted by mini-css-extract-plugin
export var alignCenter = "_62-d";
export var bannerShown = "_62-6";
export var buttonContent = "_62-0";
export var cardList = "_62-1";
export var centerContent = "_62-2";
export var chevron = "_62-3";
export var closePanelButton = "_62-k";
export var conversationContextContainer = "_62-l";
export var conversationDetailContainer = "_62-4";
export var detailWrapper = "_62-7";
export var dropdownButton = "_62-e";
export var dropdownTitle = "_62-9";
export var fullHeight = "_62-5";
export var hidden = "_62-a";
export var icon = "_62-b";
export var mergeSuggestionWrapper = "_62-m";
export var panel = "_62-i";
export var portalButtonsWrapper = "_62-c";
export var right = "_62-j";
export var tableSummaryContainer = "_62-8";
export var tableSummaryHeader = "_62-g";
export var threeDotsButton = "_62-f";
export var wide = "_62-h";